<template>
  <div
    ref="chessboard-toolbar"
    class="chessboard-toolbar"
    :class="{
      'is-review-type':
        $device.isMobile && mode !== 'courseTsume' && mode !== 'check2Chess',
      'is-check2Chess-type': mode === 'check2Chess' && $device.isMobile,
    }"
  >
    <!-- 查看變化圖 -->
    <div
      v-if="mode === 'checkVariation'"
      class="controller d-flex justify-content-between align-items-center p-2 m-md-2 position-relative"
    >
      <div
        class="questionhand-wrapper d-flex align-items-center justify-content-between w-100 flex-md-column-reverse"
      >
        <div class="d-flex" :class="{'w-100': !isMobile}">
          <b-button
            :class="isMobile ? 'btn btn-secondary mr-2' : 'btn btn-white mr-1'"
            :size="isMobile ? 'oval-sm' : 'sm'"
            @click="onItemClick('testPlay')"
          >
            <span class="icon-Try-go"></span>
            <span v-if="!isMobile" class="ml-1">{{ $t('試下') }}</span>
          </b-button>
          <b-button
            :size="isMobile ? 'oval-sm' : 'sm'"
            :class="isMobile ? 'btn btn-secondary mr-2' : 'btn btn-white'"
            @click="onItemClick('influence')"
          >
            <span class="icon-Go-status"></span>
            <span v-if="!isMobile" class="ml-1">{{ $t('當前形勢') }}</span>
          </b-button>
        </div>
        <div class="check-question-step mb-md-1">
          <b-button
            variant="secondary"
            :size="buttonSizeForMode"
            class="mr-2 mr-md-0"
            :disabled="stepControlsDisabled.prev"
            @click="checkStep('prev')"
          >
            <span v-if="isMobile" class="icon-Rewind"></span>
            <span v-else>{{ $t('上一手') }}</span>
          </b-button>
          <span v-if="isMobile" class="step-text mx-4">{{ currentStep }}</span>
          <b-button
            variant="secondary"
            :size="buttonSizeForMode"
            class="ml-2 ml-md-1"
            :disabled="stepControlsDisabled.next"
            @click="checkStep('next')"
          >
            <span v-if="isMobile" class="icon-Play"></span>
            <span v-else>{{ $t('下一手') }}</span>
          </b-button>
        </div>
        <span v-if="!isMobile" class="step-text mb-md-2">{{
          $t('變化圖') + ` ( ${currentStep} / ${maxStep} )`
        }}</span>
      </div>
    </div>
    <!-- 試下 -->
    <div
      v-else-if="mode === 'testPlay' && isMobile"
      class="controller d-flex justify-content-between align-items-center m-md-2 position-relative"
    >
      <div
        class="questionhand-wrapper d-flex align-items-center justify-content-between w-100 flex-md-column-reverse"
      >
        <div class="d-flex" :class="{'w-100': !isMobile}">
          <b-button
            :class="isMobile ? 'mr-2' : 'w-100'"
            variant="accent"
            :pill="isMobile"
            size="md"
            @click="onItemClick('testPlay')"
          >
            <span class="icon-X"></span>
            <span class="ml-1">{{ $t('離開') }}</span>
          </b-button>
          <b-button
            v-if="showInfluenceButton"
            :size="isMobile ? 'oval-sm' : 'sm'"
            :class="isMobile ? 'btn btn-secondary mr-2' : 'btn btn-white'"
            @click="onItemClick('influence')"
          >
            <span class="icon-Go-status"></span>
            <span v-if="!isMobile" class="ml-1">{{ $t('當前形勢') }}</span>
          </b-button>
        </div>
        <div class="">
          <check-kifu-step
            :current-step="currentStep || 0"
            :max-step="maxStep"
            :has-current-step="currentStep >= 0"
            @check-step="checkStep"
          />
        </div>
      </div>
    </div>
    <div v-else-if="mode === 'testPlay' && !isMobile">
      <div class="mb-md-2">
        <check-kifu-step
          :current-step="currentStep || 0"
          :max-step="maxStep"
          :has-current-step="currentStep >= 0"
          @check-step="checkStep"
        />
      </div>
      <div class="w-100">
        <b-button
          v-if="showInfluenceButton"
          size="md"
          class="w-100 btn mb-2"
          @click="onItemClick('influence')"
        >
          <span class="icon-Go-status"></span>
          <span class="ml-1">{{ $t('當前形勢') }}</span>
        </b-button>
        <b-button
          class="w-100"
          variant="accent"
          size="md"
          @click="onItemClick('testPlay')"
        >
          <span class="icon-X"></span>
          <span class="ml-1">{{ $t('離開試下') }}</span>
        </b-button>
      </div>
    </div>
    <!-- 查看答案 -->
    <div
      v-else-if="mode === 'checkAnswer'"
      class="controller d-flex flex-column align-items-center justify-content-between justify-content-md-center position-relative"
    >
      <div
        class="d-flex flex-column flex-md-column-reverse align-items-center justify-content-between w-100"
      >
        <div
          v-if="hasNextQuestion && !isMobile"
          class="d-flex w-100 mt-2 justify-content-between"
        >
          <b-button
            variant="primary"
            class="w-100"
            :size="isMobile ? 'md' : 'lg'"
            @click="onItemClick('nextQuestion')"
          >
            <h2>{{ nextQuestionButtonText }}</h2>
          </b-button>
        </div>
        <div
          v-if="hasNextStage && !isMobile"
          class="d-flex w-100 mt-2 justify-content-between"
        >
          <b-button
            variant="primary"
            class="w-100"
            :size="isMobile ? 'md' : 'lg'"
            @click="onItemClick('nextStage')"
          >
            <h2>{{ $t('下一關') }}</h2>
          </b-button>
        </div>
        <div
          v-if="hasReplay && !isMobile"
          class="d-flex w-100 mt-2 justify-content-between"
        >
          <b-button
            variant="primary"
            class="w-100"
            :size="isMobile ? 'md' : 'lg'"
            @click="onItemClick('replay')"
          >
            <h2>{{ $t('再次挑戰') }}</h2>
          </b-button>
        </div>
        <div
          :class="{'w-100': !isMobile}"
          class="d-flex w-100 flex-md-column-reverse justify-content-between align-items-center mb-3 mb-md-0"
        >
          <div :class="{'w-100': !isMobile}">
            <b-button
              v-if="hasTestPlay"
              :class="{'w-100 mt-2': !isMobile}"
              variant="secondary"
              :size="isMobile ? 'oval-sm' : 'md'"
              @click="onItemClick('testPlay')"
            >
              <span class="icon-Try-go"></span>
              <span v-if="!isMobile" class="ml-1">{{ $t('試下') }}</span>
            </b-button>
          </div>
          <div :class="{'w-100': !isMobile}">
            <check-kifu-step
              :current-step="currentStep || 0"
              :max-step="maxStep"
              :has-current-step="currentStep >= 0"
              :disable-current-step="selectedAnswerTab === 'question'"
              :disable-max-step="selectedAnswerTab === 'question'"
              @check-step="checkStep"
            />
          </div>
        </div>
        <div v-if="isMobile" class="wrap-select-question d-flex w-100">
          <template v-if="hasNextQuestion">
            <b-button
              variant="primary"
              class="w-100"
              size="md"
              @click="onItemClick('nextQuestion')"
            >
              <span>{{ nextQuestionButtonText }}</span>
            </b-button>
          </template>
          <template v-else>
            <b-button
              :disabled="questionNavigationDisabled.prev"
              variant="outline-primary"
              size="md"
              class="mr-2 prev-question w-50"
              @click="prevQuestion"
            >
              {{ $t('上一題') }}
            </b-button>
            <b-button
              :disabled="questionNavigationDisabled.next"
              variant="outline-primary"
              size="md"
              class="next-question w-50"
              @click="nextQuestion"
            >
              {{ $t('下一題') }}
            </b-button>
            <b-button
              v-if="hasNextStage"
              variant="primary"
              size="md"
              class="ml-2 next-question w-50"
              @click="onItemClick('nextStage')"
            >
              {{ $t('下一關') }}
            </b-button>
            <b-button
              v-if="hasReplay"
              variant="primary"
              size="md"
              class="ml-2 next-question w-50"
              @click="onItemClick('replay')"
            >
              {{ $t('再次挑戰') }}
            </b-button>
          </template>
        </div>
      </div>
    </div>
    <!-- 確認落子 & 快速測棋力 -->
    <div
      v-if="mode === 'check2Chess' || mode === 'quickTest'"
      class="check2Chess-btn-group justify-content-center align-items-center"
      :class="{'mb-2': isTeacher}"
    >
      <!-- 桌面版或確認落子模式顯示方向控制按鈕 -->
      <template v-if="!isMobile || mode === 'check2Chess'">
        <div class="check2Chess-btn-top">
          <b-button
            v-for="direction in ['top', 'bottom', 'left', 'right']"
            :key="direction"
            variant="secondary"
            :size="buttonSizeForMode"
            :class="getDirectionButtonClass(direction)"
            @click="moveChess(direction)"
          >
            <span :class="`icon-Big-${direction}`"></span>
          </b-button>
        </div>
      </template>

      <div class="check2Chess-btn-bottom">
        <b-button
          :variant="
            mode === 'quickTest' && isMobile ? 'secondary' : 'grayscale30'
          "
          :size="mode === 'quickTest' && isMobile ? 'lg' : buttonSizeForMode"
          :class="getCancelButtonClass"
          @click="onItemClick('moveCancle')"
        >
          <span v-if="isMobile && mode !== 'quickTest'" class="icon-X"></span>
          <span v-else>{{ $t('取消') }}</span>
        </b-button>
        <b-button
          :variant="mode === 'quickTest' && isMobile ? 'primary' : 'positive'"
          :size="mode === 'quickTest' && isMobile ? 'lg' : buttonSizeForMode"
          :class="getConfirmButtonClass"
          @click="onItemClick('moveConfirm')"
        >
          <span
            v-if="isMobile && mode !== 'quickTest'"
            class="icon-Check"
          ></span>
          <span v-else>{{ getConfirmButtonText }}</span>
        </b-button>
      </div>
    </div>
    <!-- 老師檢定試下 -->
    <div
      v-if="showTeacherTestPlay"
      class="d-flex flex-md-column justify-content-center align-items-center"
    >
      <b-button
        variant="secondary"
        size="md"
        class="try-go w-100"
        @click="onItemClick('testPlay')"
      >
        <span class="icon-Try-go"></span>
        <span class="ml-1">{{ $t('試下（限教學）') }}</span>
      </b-button>
    </div>

    <!-- 做題 -->
    <div
      v-if="mode === 'courseTsume' && !isVerification"
      class="check2Chess-btn-group justify-content-center align-items-center"
      :class="isTeacher ? 'mt-2' : ''"
      style="gap: 8px"
    >
      <div class="w-100 d-flex" style="gap: 8px">
        <b-button
          variant="infoAndLink"
          :size="isMobile ? 'md' : 'lg'"
          style="flex: 1"
          :disabled="isAnswering"
          @click="onItemClick('watchAnswer')"
        >
          <h2>{{ $t('看解答') }}</h2>
        </b-button>
        <b-button
          variant="primary"
          :disabled="isAnswering"
          :size="isMobile ? 'md' : 'lg'"
          style="flex: 1"
          @click="onItemClick('nextQuestion')"
        >
          <h2>{{ nextQuestionButtonText }}</h2>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '@/i18n/index';
import CheckKifuStep from '@/components/Kifu/CheckKifuStep.vue';

export default {
  components: {
    CheckKifuStep,
  },
  props: {
    mode: {
      type: String,
      default: '',
      validator: (val) => {
        return [
          'game',
          'pvp',
          'check2Chess',
          'checkKifu',
          'checkAnswer',
          'board',
          'checkVariation',
          'testPlay',
          'teacherTsume',
          'quickTest',
          'courseTsume',
          '',
        ].includes(val);
        // 下棋、確認落子、查看棋譜、查看做題結果
      },
    },
    stepType: {
      type: String,
      default: 'normal',
    },
    currentStep: {
      type: Number,
      default: 0,
    },
    maxStep: {
      type: Number,
      default: 0,
    },
    question: {
      type: Object,
      default: () => {
        return {};
      },
    },
    hasSupportGame: {
      type: Boolean,
      default: false,
    },
    hasInfluence: {
      type: Boolean,
      default: false,
    },
    hasTestPlay: {
      type: Boolean,
      default: true,
    },
    hasJudge: {
      type: Boolean,
      default: true,
    },
    hasNextQuestion: {
      type: Boolean,
      default: false,
    },
    hasNextStage: {
      type: Boolean,
      default: false,
    },
    hasReplay: {
      type: Boolean,
      default: false,
    },
    supportCount: {
      type: Number,
      default: 0,
    },
    kifuReviewGame: {
      type: Object,
      default: null,
    },
    webSelectedAnswerTab: {
      type: String,
      default: 'question',
    },
    isAnswering: {
      type: Boolean,
      default: false,
    },
    isLastQuestion: {
      type: Boolean,
      default: false,
    },
    questionIndex: {
      type: Number,
      default: 0,
    },
    questionsLength: {
      type: Number,
      default: 0,
    },
    isVerification: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedAnswerTab: 'question',
      selectedAnswerIndex: -1,
    };
  },
  computed: {
    locale() {
      return i18n.locale;
    },
    isTeacher() {
      return this.$store.getters['user/isTeacher'];
    },
    width() {
      return this.$store.state.env.width;
    },
    excellentHandLength() {
      return this.kifuReviewGame ? this.kifuReviewGame.excellentHand.length : 0;
    },
    questionHandLength() {
      return this.kifuReviewGame ? this.kifuReviewGame.questionHand.length : 0;
    },
    reviewMarks() {
      let _reviewMarks = [];
      if (
        this.kifuReviewGame &&
        (this.kifuReviewGame.excellentHand || this.kifuReviewGame.questionHand)
      ) {
        const excellentHandMarks = {};
        const questionHandMarks = {};
        this.kifuReviewGame.excellentHand.forEach((step) => {
          excellentHandMarks[step.stepNum] = {
            style: {
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              boxShadow: '0 0 0 3px #2F9A3D',
              backgroundColor: '#2F9A3D',
            },
          };
        });
        this.kifuReviewGame.questionHand.forEach((step) => {
          questionHandMarks[step.stepNum] = {
            style: {
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              boxShadow: '0 0 0 3px #F35D23',
              backgroundColor: '#F35D23',
            },
          };
        });
        _reviewMarks = {...excellentHandMarks, ...questionHandMarks};
      }
      return _reviewMarks;
    },
    currentPlan() {
      return this.$store.getters['course/currentPlan'];
    },
    isLanguageSupported() {
      const videoLanguages = this.currentPlan?.commentaryVideoLanguages;
      return videoLanguages && videoLanguages.includes(this.locale);
    },
    isMobile() {
      return this.$device.isMobile;
    },
    buttonSizeForMode() {
      return this.isMobile ? 'oval-sm' : 'md';
    },
    stepControlsDisabled() {
      return {
        prev: this.currentStep === 0,
        next: this.currentStep === this.maxStep || this.maxStep <= 1,
      };
    },
    questionNavigationDisabled() {
      return {
        prev: this.questionIndex === 0,
        next: this.questionIndex === this.questionsLength - 1,
      };
    },
    showInfluenceButton() {
      return !this.question && this.mode !== 'courseTsume';
    },
    nextQuestionButtonText() {
      return this.isLastQuestion ? this.$t('結束') : this.$t('下一題');
    },
    showTeacherTestPlay() {
      return (
        this.isTeacher &&
        !this.isMobile &&
        (this.mode === 'teacherTsume' ||
          (this.mode !== 'testPlay' && this.mode !== 'checkAnswer'))
      );
    },
    getCancelButtonClass() {
      if (this.mode === 'quickTest' && this.isMobile) {
        return 'mr-3';
      }
      return this.isMobile ? 'mx-2' : 'mr-1';
    },
    getConfirmButtonClass() {
      if (this.mode === 'quickTest' && this.isMobile) {
        return '';
      }
      return this.isMobile ? 'ml-2' : 'ml-1';
    },
    getConfirmButtonText() {
      if (this.mode === 'quickTest') {
        return this.$t('確定');
      }
      return this.$t('確定落子');
    },
  },
  watch: {
    webSelectedAnswerTab(newValue) {
      this.selectedAnswerTab = newValue;
    },
  },
  methods: {
    onItemClick(event) {
      this.$emit('item-click', event);
    },
    moveChess(direction) {
      this.$emit('move-chess', direction);
    },
    getDirectionButtonClass(direction) {
      const baseClass = this.isMobile ? 'mx-2' : '';
      const directionClasses = {
        top: this.isMobile ? 'mx-2' : 'mr-1',
        bottom: this.isMobile ? 'mx-2' : 'mx-1',
        left: this.isMobile ? 'mx-2' : 'mx-1',
        right: this.isMobile ? 'mx-2' : 'ml-1',
      };
      return directionClasses[direction] || baseClass;
    },
    onCheckAnswerClick(value) {
      this.selectedAnswerTab = value;
      this.$emit('check-answer-tab', value);
    },
    onClickVideo(question) {
      this.$emit('on-click-video', question);
    },
    checkStep(event) {
      this.$emit('check-step', event);
    },
    stepChange(step) {
      this.$emit('step-change', step);
    },
    prevQuestion() {
      this.$emit('prev-question');
    },
    nextQuestion() {
      this.$emit('next-question');
    },
    isVideoButtonShow(question) {
      return question.videoId && this.isLanguageSupported;
    },
  },
};
</script>

<style lang="scss" scoped>
// 通用變量
$desktop-breakpoint: 768px;
$toolbar-bg: #fff;
$shadow-color: rgba(199, 199, 199, 0.4);
$disabled-bg: #ced4da;
$icon-size-desktop: 16px;
$button-height-desktop: 48px;

// Mixin for desktop styles
@mixin desktop-only {
  @media screen and (min-width: $desktop-breakpoint) {
    @content;
  }
}

.chessboard-toolbar {
  &.is-review-type {
    position: sticky;
    bottom: 0;
    left: 0;
    border-radius: 10px 10px 0 0;
    background: $toolbar-bg;
    box-shadow: 0 -2px 7px 0 $shadow-color;
    .controller {
      padding: 16px;
    }
  }
  &.is-check2Chess-type {
    border-radius: 10px;
    background: $toolbar-bg;
    padding: 4px;
  }
}

// Button group styles
.checkKifu-btn-group {
  .hand {
    @include desktop-only {
      width: 100%;
    }

    .icon-Hand-triangle,
    .icon-Hand-All,
    .icon-Elert-info,
    .icon-Try-go,
    .icon-Go-status {
      @include desktop-only {
        font-size: $icon-size-desktop;
        position: relative;
        top: 2px;
      }
    }
  }

  .btn-white,
  .btn-one-step {
    @include desktop-only {
      width: calc(50% - 2px);
    }
  }
}

.check2Chess-btn-group {
  display: flex;
  @include desktop-only {
    flex-direction: column;
  }
  .check2Chess-btn-top {
    display: flex;

    @include desktop-only {
      margin-bottom: 8px;
      width: 100%;
      .btn {
        width: 25%;
        height: 48px;
        padding: 8px 0;
        > span {
          font-size: 32px;
        }
      }
    }
  }

  .check2Chess-btn-bottom {
    display: flex;

    @include desktop-only {
      width: 100%;

      .btn {
        width: 50%;
        height: $button-height-desktop;

        > span {
          font-size: 20px;
          font-weight: 700;
        }
      }
    }
  }
}

// Layout styles
.step-text {
  text-align: center;

  @include desktop-only {
    line-height: 28px;
  }
}

.check-question-step {
  @include desktop-only {
    width: 100%;

    .btn-secondary {
      width: calc(50% - 2px);
    }
  }
}

.questionhand-wrapper {
  @include desktop-only {
    height: auto;
    width: 100%;
  }
}

.desktop-current-step {
  background: #00000005;
  flex: 1;
  line-height: 46px;
  border-radius: 10px;
}

// Button disabled states
%disabled-button {
  background: $disabled-bg;
  border-color: $disabled-bg;
  cursor: not-allowed;
}

.btn-infoAndLink.disabled,
.btn-infoAndLink:disabled {
  @extend %disabled-button;
}

.btn-accent.disabled,
.btn-accent:disabled {
  @extend %disabled-button;
}

// Typography
.btn-md > h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
}
</style>
